import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
const defaultOptions = {} as const;

export const UpdateSalesRepPriceOverrideDocument = gql`
  mutation UpdateSalesRepPriceOverride(
    $restaurantUUID: uuid!
    $supplierUUID: uuid!
    $variantPacks: [SalesRepUpdateVariantPackInput!]!
    $deliveryDate: String
    $expirationDate: String
  ) {
    updateSalesRepPrice(
      delivery_date: $deliveryDate
      expiration_date: $expirationDate
      restaurant_id: $restaurantUUID
      supplier_id: $supplierUUID
      update_source: ORDER_ENTRY
      variant_packs: $variantPacks
    ) {
      variant_pack_id
      default_price_in_micros
      price_in_micros
      sales_rep_price_in_micros
      sales_rep_gross_profit_in_percentage
      sales_rep_metadata {
        updated_by_name
      }
      unit_count
    }
  }
`;
export type UpdateSalesRepPriceOverrideMutationFn = Apollo.MutationFunction<
  Types.UpdateSalesRepPriceOverrideMutation,
  Types.UpdateSalesRepPriceOverrideMutationVariables
>;
export function useUpdateSalesRepPriceOverrideMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateSalesRepPriceOverrideMutation,
    Types.UpdateSalesRepPriceOverrideMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.UpdateSalesRepPriceOverrideMutation,
    Types.UpdateSalesRepPriceOverrideMutationVariables
  >(UpdateSalesRepPriceOverrideDocument, options);
}
export type UpdateSalesRepPriceOverrideMutationHookResult = ReturnType<
  typeof useUpdateSalesRepPriceOverrideMutation
>;
export type UpdateSalesRepPriceOverrideMutationResult =
  Apollo.MutationResult<Types.UpdateSalesRepPriceOverrideMutation>;
export type UpdateSalesRepPriceOverrideMutationOptions =
  Apollo.BaseMutationOptions<
    Types.UpdateSalesRepPriceOverrideMutation,
    Types.UpdateSalesRepPriceOverrideMutationVariables
  >;
